module.exports = __webpack_public_path__ + "img/mobile-5.44cd3c56.png";